import { DeclineCandidateSuccessPopup } from '../../PermanentJobsV2/JobOverview/components';

/**
 * Success popup shown after declining a candidate on an onsite-interview job.
 * The caller owns the close behavior via `onClose`.
 */
export const DeclineSuccessPopups = ({ professionalName, onClose }) => (
  <DeclineCandidateSuccessPopup professionalName={professionalName} onClose={onClose} />
);
